import { Flex, Image, Popconfirm, Tooltip } from 'antd';
import {
  Container,
  Description,
  StepImageContainer,
  CauseName,
  DeleteButton,
  StepSigns,
  StepSignImage,
  DragHandle,
} from './style';
import { Step } from '../../types';
import Icon, { MenuOutlined } from '@ant-design/icons';
import { SVGEdit, SVGUnlink } from '../../images';
import {
  getIso7010SignImagePath,
  iso7010SignDescriptions,
  parseSignNames,
} from '../../constants/signs';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useTranslation } from 'react-i18next';

const StepCard = ({
  step,
  onDelete,
  onEdit,
  readOnly,
  isDragging,
}: {
  step: Step;
  onDelete: () => void;
  onEdit: () => void;
  readOnly?: boolean;
  isDragging?: boolean;
}) => {
  const { t } = useTranslation();
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: step.routineStepID });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Container
      ref={setNodeRef}
      style={{
        ...style,
        opacity: isDragging ? 0.5 : 1,
      }}
      vertical
      gap={8}
    >
      <Flex gap={8}>
        {!readOnly && (
          <DragHandle {...attributes} {...listeners}>
            <MenuOutlined />
          </DragHandle>
        )}
        <StepImageContainer>
          <Image
            src={step.images?.[0]?.url}
            preview={!!step.images?.[0]?.url}
            fallback="/placeholder.png"
          />
        </StepImageContainer>
        <Flex vertical flex={1}>
          <CauseName>{step.name}</CauseName>
          {!!step.signNames && (
            <StepSigns>
              {parseSignNames(step.signNames).map((code) => (
                <Tooltip
                  key={code}
                  title={`${code} - ${iso7010SignDescriptions[code]}`}
                >
                  <StepSignImage
                    src={getIso7010SignImagePath(code)}
                    alt={code}
                    title={code.toLowerCase()}
                  />
                </Tooltip>
              ))}
            </StepSigns>
          )}
        </Flex>
        {!readOnly && (
          <Flex align="center">
            <DeleteButton style={{ fontSize: 16 }} onClick={onEdit}>
              <Icon component={SVGEdit} />
            </DeleteButton>
            <Popconfirm
              placement="topRight"
              title={t('remove_step_confirmation')}
              okText={t('yes')}
              cancelText={t('no')}
              onConfirm={onDelete}
            >
              <DeleteButton>
                <Icon component={SVGUnlink} />
              </DeleteButton>
            </Popconfirm>
          </Flex>
        )}
      </Flex>
      {/* {step.description && (
        <Description>{step.description.replace(/<[^>]*>/g, '')}</Description>
      )} */}
      {step.description && (
        <Description
          dangerouslySetInnerHTML={{
            __html: step?.description || '',
          }}
        ></Description>
      )}
    </Container>
  );
};

export default StepCard;
